import request from '@/utils/request';

/** 文件上传返回 */
export interface UploadResult {
    url: string;
    id: string | number;
}

/**
 * @name getOssToken
 * @description 获取上传临时上传凭证
 */
export const getOssToken = function () {
    return request.http<{
        access_key_id: string;
        access_key_secret: string;
        security_token: string;
        expiration: string;
        request_id: string;
    }>({
        method: 'GET',
        url: '/oss_token'
    });
};

/**
 * @name getDictListByParentIds
 * @description 获取商家字典
 */
export const getDictListByParentIds = function (data: { parentIds: string[]; filterCodes?: string[] }) {
    return request.http<Record<string, unknown>>({
        method: 'POST',
        url: '/chsDict/getDictListByParentIds.json',
        data
    });
};

export const getDictListByParentCodeExtras = function (data: { parentCodeExtras: string[]; filterCodes?: string[] }) {
    return request.http<Record<string, unknown>>({
        method: 'POST',
        url: '/chsDict/getDictListByParentCodeExtras.json',
        data
    });
};

/**
 * @name saveChsDict
 * @description 保存/更新商家字典
 */
export const saveChsDict = function (data: {
    id?: number;
    businessId?: number;
    parentId?: number;
    parentName?: string;
    code?: string;
    name: string;
    remark?: string;
    updateCount?: number;
}) {
    return request.http<number>({
        method: 'POST',
        url: '/chsDict/save.json',
        data,
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
    });
};

/**
 * @name deleteChsDict
 * @description 删除商家字典
 */
export const deleteChsDict = function (id: number) {
    return request.http<number>({
        method: 'POST',
        url: '/chsDict/deleteById.json',
        data: { id },
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
    });
};

/**
 * @name getSystemDict
 * @description 获取系统字典
 */
export const getSystemDict = function (data: { parentCodeExtras: string[]; filterCodes?: string[] }) {
    return request.http<Record<string, unknown>>({
        method: 'POST',
        url: '/chsDict/getSysDictListByParentCodeExtras.json',
        data
    });
};

/**
 * @name getSysDictListByParentIds
 * @description 根据父ID列表批量获取系统字典
 */
export const getSysDictListByParentIds = function (data: { parentIds: number[] }) {
    return request.http<Record<string, any[]>>({
        method: 'POST',
        url: '/chsDict/getSysDictListByParentIds.json',
        data
    });
};

/**
 * @name uploadImg
 * @description 上传图片
 */
export const uploadImg = function (data: FormData | Record<string, unknown>) {
    return request.http<UploadResult>({
        method: 'POST',
        url: '/chsFile/upload.json',
        data,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

/**
 * @name uploadImage
 * @description 上传图片（带业务ID）
 */
export const uploadImage = function (data: FormData | Record<string, unknown>, onUploadProgress?: (progressEvent: any) => void) {
    return request.http<UploadResult>({
        method: 'POST',
        url: '/chsFile/upload.json',
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress
    });
};

/**
 * @name uploadExtra
 * @description 上传图片并识别（营业执照/身份证等）
 */
export const uploadExtra = function (data: FormData) {
    return request.http<Record<string, string>>({
        method: 'POST',
        url: '/chsFile/uploadExtra.json',
        data,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
